<template>
  <div class="footer">
    <div class="footer__left">
      &copy; Copyright 2021 Portland Patent
    </div>
    <div class="footer__right">
      <ul>
        <li><router-link to="/privacy-policy">Privacy Policy</router-link></li>
        <li><router-link to="/terms-of-service">Terms of Service</router-link></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
.footer {
  background-color: $primary;
  color: white;
  min-height: 100px;
  padding: 2em 6em;
  text-align: right;
  display: flex;
  justify-content: space-between;
  @media($sm-down) {
    padding: 2em;
    text-align: center;
    display: block;
  }
  a {
    color: white;
  }
  &__left {
    @media($sm-down) {
      margin-bottom: 20px;
    }
  }
  ul {
    li {
      display: inline-block;
      list-style: none;
      margin-right: 30px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>